import React from "react";

import {
  Button,
  ButtonVariant,
  Flex,
  FlexItem
} from "@patternfly/react-core";

import { TimesIcon } from "@patternfly/react-icons";

import SchoolHeaderBrand from "../../top/SchoolHeaderBrand/SchoolHeaderBrand";

import useNavigation from "../hooks/useNavigation";

import "./SchoolMobileHeader.css";

const SchoolMobileHeader = () => {
  const { closeMobileMenu } = useNavigation();

  return (
    <div className="school-mobile-header">
      <Flex
        justifyContent={{ default: "justifyContentSpaceBetween" }}
        alignItems={{ default: "alignItemsCenter" }}
        flexWrap={{ default: "nowrap" }}
      >
        <FlexItem grow={{ default: "grow" }}>
          <div className="school-mobile-header__brand">
            <SchoolHeaderBrand variant="mobile" />
          </div>
        </FlexItem>

        <FlexItem flex={{ default: "none" }}>
          <Button
            variant={ButtonVariant.plain}
            icon={<TimesIcon />}
            onClick={closeMobileMenu}
            aria-label="Close navigation"
          />
        </FlexItem>
      </Flex>
    </div>
  );
};

export default SchoolMobileHeader;